import {Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {IDocument} from "../../interfaces/document.definition";
import {NvFileUploader} from "../../classes/nv-file-uploader/nv-file-uploader.class";
import {FileLikeObject} from "ng2-file-upload";
import {ModalService} from "../../services/modal.service";
import {AnimationsService, IAnimationInfo} from "../../services/animations.service";
import {ErrorService} from "../../services/error.service";
import {CollectionService} from "../../services/collection.service";
import {DocumentService} from "../../services/document.service";
import {PreloaderService} from "../../services/preloader.service";
import {Subject} from "rxjs/Subject";
import {APP_MESSAGES, DOCUMENT_TYPES} from "../../enums/enums";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {NvSelect2Component} from "../../components/nv-select/nv-select2.component";
import {JP} from "app/helpers/jp";
import {WatchService} from "../../services/watch.service";

declare const $: any;

@Component({
  selector: 'nv-load-img-modal',
  templateUrl: './nv-load-img-modal.component.html',
  styles: []
})
export class NvLoadImgModalComponent implements OnInit, OnDestroy {

  @ViewChildren(NvSelect2Component) selects:QueryList<NvSelect2Component>;
  @ViewChild("modalRoot") element:ElementRef;

  private unsubscribe: Subject<void> = new Subject<void>();
  private _document: IDocument;
  private imgId: string = "testImg/testImg";
  private imageInfo: IAnimationInfo;
  loadedAtlases: IDocument[] = [];
  hasBaseDropZoneOver: boolean = false;
  uploader = new NvFileUploader({
    queueLimit:1,
    url: "/animations/upload",
    removeAfterUpload: true,
    filters:[ { name: "filename-filter", fn: (file: FileLikeObject):boolean => {
      const filename = file ? file.name : "";
      console.log(/\.png$/i.test(filename));
      return /\.png$/i.test(filename);
    }}]
  });

  constructor(private modalService: ModalService,
              private animationsService: AnimationsService,
              private errorService: ErrorService,
              private collectionService: CollectionService,
              private documentService:DocumentService,
              private preloaderService:PreloaderService,
              private watchService:WatchService) {
  }

  ngOnInit() {
    this.modalService
      .onModalRequest
      .takeUntil(this.unsubscribe)
      .filter(
        appMessage => appMessage.type === APP_MESSAGES.POPUP_IMAGE_EDITOR_MODAL)
      .subscribe((appMessage) => {
        this.imgId = appMessage.content.pointer;
        this.show(<IDocument>appMessage.content.document);
      });

    this.uploader.onCompleteAll = () => {
      this.onUploadComplete();
    }

    this.uploader
      .onError
      .subscribe((response: string): void => this.onUploadError(response));

    this.loadAtlasesList();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onAtlasChanged() {
    this.animationsService
      .updateDestinationAtlas("image","" + this._document.id, this._document._type, this.imgId, this.imageInfo.atlas)
      .subscribe(() => {});
  }

  onUploadAllClick() {
    this.preloaderService.show();
    var readQueue = [];
    for (let file of this.uploader.queue)
    {
      readQueue.push(this.readFile(file.file));
    }

    Promise.all(readQueue)
      .then(results => {
        this.preloaderService.hide();

        this.animationsService
          .clearContent("image","" + this._document.id, this._document._type, this.imgId)
          .subscribe(() => {
            this.preloaderService.show();
            this.uploader.options.headers = [
              {name: "ownerId", value: "" + this._document.id},
              {name: "ownerType", value: this._document._type},
              {name: "type", value: "image"},
              {name: "imgId", value: this.imgId},
            ];
            this.uploader.uploadAll();
          });
      });
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }



  private show(document: IDocument) {
    this._document = document;
    $(this.element.nativeElement).modal();
    this.loadImageInfo();
  }

  private readFile(file:FileLikeObject):Promise<any> {
    return new Promise<any>((resolve) => {
      let reader:FileReader = new FileReader();
      reader.onloadend = function (e) {
          return resolve({fileName: file.name, content: btoa(reader.result)});
       }
      reader.readAsBinaryString(new Blob([file.rawFile]));
    });
  }

  private loadAtlasesList() {
    const params = paramsHelper
      .loader()
      .setEndpointId(E_ENDPOINTS.API)
      .setObjectType(DOCUMENT_TYPES.ATLAS)
      .setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params)
      .subscribe(r => {
        this.loadedAtlases = r.documents;
        this.updateAtlasesSelects();
      })
  }

  private loadImageInfo() {
    this.animationsService
      .loadInfo("image", this._document.id.toString(), this._document._type, this.imgId)
      .subscribe(
        a => {
          this.imageInfo = a;
          if (this.imageInfo.content.length > 0)
          {
            JP.set(this._document, this.imgId, this.imageInfo.content[0]);
          }
        });
  }

  private updateAtlasesSelects() {
    if (!this.selects) {
      return;
    }
    this.selects
      .forEach((select: NvSelect2Component): void => select.setItems(this.loadedAtlases));
  }

  private onUploadComplete() {
    this.preloaderService.hide();
    this.watchService.notify();
    this.loadImageInfo();
  }

  private onUploadError(response: string) {
    this.errorService.handleError(new Error(`Upload error: ${response}`));
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/modals/nv-load-img-modal/nv-load-img-modal.component.ts